type VetoLogoProps = {
  /** Height in pixels; text scales from the previous wordmark footprint. */
  height?: number;
  /** Use on dark backgrounds (#191919, navy panels). */
  onDark?: boolean;
  className?: string;
  alt?: string;
};

/** Text wordmark; avoids root asset requests that may be protected by Access on custom domains. */
export function VetoLogo({ height = 28, onDark = false, className = "", alt = "Veto" }: VetoLogoProps) {
  const fontSize = Math.max(16, Math.round(height * 0.72));

  return (
    <span
      aria-label={alt}
      className={`inline-flex items-center font-semibold tracking-normal ${onDark ? "text-white" : "text-zinc-950"} ${className}`.trim()}
      style={{ minHeight: height, fontSize, lineHeight: `${height}px` }}
    >
      Veto
    </span>
  );
}

/** Compact mark for push notifications and phone chrome. */
export function VetoLogoMark({
  size = 40,
  onDark = false,
  className = ""
}: {
  size?: number;
  onDark?: boolean;
  className?: string;
}) {
  return (
    <div
      className={`flex shrink-0 items-center justify-center overflow-hidden rounded-lg bg-white ${className}`.trim()}
      style={{ width: size, height: size }}
    >
      <VetoLogo height={Math.round(size * 0.55)} onDark={onDark} className="max-h-[85%] max-w-[85%] object-contain" />
    </div>
  );
}
